<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet comment-sheet"
  >
    <v-card>
      <v-card-title>
        댓글
        <v-spacer />
        <v-btn icon @click="close">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text class="sheet-body">
        <!-- 데이터 로딩 -->
        <div class="no-data" v-if="isLoading">
          <v-progress-circular indeterminate size="32" />
        </div>
        <!-- 데이터 없음 -->
        <div class="no-data" v-else-if="getSquareCmntListResult.length === 0">
          <div class="no-data-text">댓글이 없습니다.</div>
        </div>
        <template v-else v-for="(item, index) in getSquareCmntListResult">
          <!-- item.prtsCmntNo === null 답글의 답글 -->
          <div class="unit-item" :class="[
            {'comment' : item.prtsCmntNo},
            {'edit' : editMode && item.cmntNo === editItem.cmntNo},
            {'edit' : editMode && item.cmntNo === editItem.cmntNo},
            `comment-unit-item-${index}`]"
               :key="index"
          >
            <div class="unit-header">
              <div class="d-flex align-center">
                <v-avatar min-width="42" width="42" height="42">
                  <v-img :src="usrAvatarUrl(item.profileAtchNo,  item.profileAtchFileName, item.clientNo)" />
                </v-avatar>
                <span class="name">{{ item.cmntRegNickNm }}</span>
              </div>
              <v-btn v-if="isSamsungFire && item.cmntRegUserKey === userKey" icon plain :ripple="false" class="btn-menu"
                     @click="$emit('onEvent', {fn: 'menuModalOpen', item: item, index: index, gubun: 'cmnt'})"></v-btn>

              <v-btn v-if="!isSamsungFire && item.adminRegYn !== 'Y'" icon plain :ripple="false" class="btn-menu"
                     @click="$emit('onEvent', {fn: 'menuModalOpen', item: item, index: index, gubun: 'cmnt'})"></v-btn>
            </div>
            <div class="unit-body">
              <div class="unit-text">
                <div class="text-pre-wrap">{{ item.cmntContent.replace(/\n$/gm, '').trim() }}</div>
              </div>
            </div>
            <div class="unit-footer">
              <span>{{ item.beforeDiff }}</span>
              <v-btn v-if="item.prtsCmntNo === null"
                     text plain :ripple="false" class="fs-12"
                     @click="cmntRe(item, index)" :color="replyStyle(item)">답글달기</v-btn>
            </div>
          </div>
        </template>
      </v-card-text>
      <!-- 신규 작성 && 수정 빈값-->
      <div class="sheet-add">
        <!-- 신규작성 -->
        <template v-if="isEmpty(editItem) && isEmpty(cmntReItem)">
          ※ 욕설 혹은 비방글을 남기면<br/>
          운영 정책에 의해 서비스 이용이 제한될 수 있습니다.
        </template>
        <!-- 새답글작성 -->
        <template v-else-if="!isEmpty(cmntReItem)">
          {{ cmntReItem.cmntRegNickNm }}님에게 답글 남기는 중...
          <v-spacer />
          <v-btn text plain small class="fs-12 me-n3" @click="editMode = false; cmntReItem = {}; content = ''">취소</v-btn>
        </template>
        <!-- 내답글수정 -->
        <template v-else-if="!isEmpty(editItem)">
          <div class="sheet-add-edit">{{ editItem.cmntContent }}</div> 수정중...
          <v-spacer />
          <v-btn text plain small class="fs-12 me-n3" @click="editMode = false; editItem = {}; content = ''">취소</v-btn>
        </template>
      </div>
      <v-card-actions class="chat-form-wrap">
        <v-form class="chat-form" v-model="valid">
          <div class="chat-input" ref="content">
            <v-textarea flat solo auto-grow no-resize row="1" row-height="1"
                        placeholder="내용을 입력해주세요"
                        hide-details
                        v-model="content"
                        ref="content"
                        :rules="[rules.required, rules.trim, rules.length(500)]"
            />
            <v-btn text :ripple="false"
                   color="primary"
                   class="btn-send-chat"
                   id="sendIcon"
                   :disabled="content.trim() === '' || content.length > 200 || !valid"
                   @click="cmntGubun()">전송
            </v-btn>
          </div>
        </v-form>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import store from '@/store'
import {mixinAuth, mixinRemote, mixinReward} from '@/mixins'
import Close from '@/components/icons/Close'

export default {
  components: { Close },
  mixins: [mixinAuth, mixinRemote, mixinReward],
  data: () => ({
    sheet: false,
    isLoading: false,
    getSquareCmntListResult: [],
    content: '',
    editMode: false,
    editItem: {},
    cmntReItem: {},
    valid: false,
    rules: {
      required: v => !!v || '필수 값입니다.',
      trim: v => (!!v && v.trim() !== '') || '공백만 작성 할 수 없습니다.',
      length: len => v => (v || '').length <= len || `${len}자 미만으로 작성 할 수 있습니다.`,
    }
  }),
  computed: {
    replyStyle() {
      return (item) => {
        if (!this.editMode && this.cmntReItem.cmntNo === item.cmntNo) {
          return 'primary'
        }
        return ''
      }
    }
  },
  created() {
  },
  methods: {
    open (value) {
      this.payload = value
      this.readList(value.item.squareNo)
    },
    close () {
      this.sheet = false
      this.payload = null
      this.isLoading = false
      this.getSquareCmntListResult = []
      this.content = ''
      this.editMode = false
      this.editItem = {}
      this.cmntReItem = {}
      this.valid = false
    },
    isEmpty(param) {
      return Object.keys(param).length === 0;
    },
    usrAvatarUrl(profileAtchNo, profileAtchFileName, clientNo) {
      // let avartar = this.avatarImages.filter(a => a.key === profileAtchNo)
      // if (avartar.length) return avartar[0].url
      // else return this.avatarImages[0].url

      let avatar = null
      if(profileAtchNo == null || profileAtchNo < 1){
        if(this.isSamsungFire){
          avatar = this.avatarImages.filter(a => a.key === profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        } else{
          return require('@/assets/images/bi/bi_img.png')
        }

      } else{

        if (clientNo == 'samsungfire') { // 삼성화재

          avatar = this.avatarImages.filter(a => a.key === profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        }else{
          avatar = profileAtchFileName
          return this.$downUrl(avatar)
        }
      }
    },
    cmntRe(item, index) {
      this.editMode = false
      this.editItem = {}
      this.cmntReItem = item;
      this.focusTextarea(index)
    },
    async cmntGubun() {
      this.valid = true
      await store.dispatch('getSquareRegistPossible', this.$_payload({'gb': '02'}))
          .then(res => {
          if (res.success) {
            if (res.data != null){ // 징계중 작성불가
              this.$alert("회원님은 댓글 징계중("+ res.data.pnshStartDt+" ~ "+ res.data.pnshEndDt +")으로 댓글 남기기가 어려워요.")
            } else{  // 작성가능
              if (this.editMode) {
                this.cmntModify();
              } else {
                this.cmntCreate();
              }
            }
          } else {
            this.$alert("작성 가능여부 조회에 실패하였습니다.")
          }
        }).catch(error => {
          console.error(error)
        }).finally(() => {
            this.valid = false
        })
    },
    editModeSetting(value) {
      this.editMode = true
      this.cmntReItem = {}
      this.editItem = this.getSquareCmntListResult[value.index]
      this.content = this.editItem.cmntContent.replace(/\n$/gm, '').trim()
      this.focusTextarea(value.index)

    },
    focusTextarea (value) {
      let index = (value) ? value : 0
      this.$nextTick(() => {
        this.$refs.content.$refs
        let content = this.$refs.content
        content.querySelector('textarea').focus()
        window.document.body.querySelector('.comment-sheet .sheet-body').scrollTop = document.querySelector(`.comment-unit-item-${index}`).offsetTop - 60
      })
    },
    async readList(squareNo) {
      this.isLoading = true
      await store.dispatch('getSquareCmntList', this.$_payload({'squareNo': squareNo}))
          .then(res => {
            if (res.success) {
              this.getSquareCmntListResult = res.data

              //TODO 호출 뙬때마다 리스트에 cmntCnt 갱신
              this.$emit('onEvent', { fn: 'addCmntList', item: { cmntCnt: this.getSquareCmntListResult.length }, index: this.payload.index })

              this.sheet = true
            } else {
              console.log(res.msg)
              this.getSquareCmntListResult = []
            }
          })
          .catch(error => {
            console.error(error)
            this.getSquareCmntListResult = []
          })
          .finally(() => {
            this.isLoading = false
          })
    },

    // 등록
    async cmntCreate() {
      let params = {
        content: this.content,
        squareNo: this.payload.item.squareNo,
        prtsCmntNo: this.cmntReItem.cmntNo
      }
      await store.dispatch('setSquareCmntRegist', this.$_payload('ba', params))
          .then(res => {
            if (res.success) {
              this.readList(this.payload.item.squareNo);
              this.cmntReItem = {};
              this.content = '';
              this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 1, '0008')
              // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', this.$store.state.auth.authUser.userKey, 1, '0008')
            } else {
              console.log(res.msg);
              this.cmntReItem = {};
            }
          })
          .catch(error => {
            console.error(error);
            this.cmntReItem = {};
          })
          .finally(() => {
          })
    },

    // 수정
    async cmntModify() {
      let params = {
        content: this.content,
        cmntNo: this.editItem.cmntNo,
        squareNo: this.editItem.cmntSquareNo
      }
      await store.dispatch('setModifyCmnt', this.$_payload({'cmntNo': this.editItem.cmntNo}, params))
          .then(res => {
            if (res.success) {
              this.readList(this.editItem.cmntSquareNo)
              this.editItem = {}
              this.content = ''
              this.editMode = false
            } else {
              console.log(res.msg)
              this.editItem = {}
            }
          })
          .catch(error => {
            console.error(error);
            this.editItem = {};
          })
          .finally(() => {
          })
    }
  }
}
</script>


